export default "__VITE_PUBLIC_ASSET__9cff0ba6__"